import React from "react"

import Breadcrumb from "components/Common/Breadcrumb"
import { CardBody, Col, Container, Input, Row, Card, Label } from "reactstrap"
import { toast } from "react-toastify"
import { useHistory, useLocation } from "react-router-dom"
import SelectBox from "components/Common/SelectBox"
import SButton from "components/Common/Button"
import { useDispatch, useSelector } from "react-redux"
import { getProductCategoryList, getProductList } from "store/actions"
import {
  getSpecificationByIdAPI,
  postSpecificationAPI,
  putSpecificationAPI,
} from "helpers/specification_helper"
import BackButton from "components/Common/BackButton"

function SpecificationManagement() {
  const dispatch = useDispatch()
  const categoryList = useSelector(
    ({ productCategory }) => productCategory?.list
  )
  const productList = useSelector(({ products }) => products?.list)

  const formatOption = [
    { value: "ラジオボタン", label: "ラジオボタン" },
    { value: "プルダウン", label: "プルダウン" },
    { value: "チェックボックス", label: "チェックボックス" },
    { value: "TEXT", label: "TEXT" },
  ]

  const answerOption = [
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: 5 },
    { value: 6, label: 6 },
  ]

  const history = useHistory()
  let location = useLocation()

  const params = new URLSearchParams(location.search)
  const id = params.get("id")

  const [formState, setFormState] = React.useState("create")

  const [field, setField] = React.useState({
    categoryId: 0,
    productId: "",
    productName: "",
    item: "",
    format: "TEXT",
    answer: 1,
    labels: [],
  })

  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const onSubmit = async () => {
    setIsSubmitting(true)
    const productAPI =
      formState === "create"
        ? postSpecificationAPI(field)
        : putSpecificationAPI(field, id)

    try {
      await productAPI
      setIsSubmitting(false)
      history.push("/master/specification")
    } catch (error) {
      setIsSubmitting(false)

      let {
        data: { errors },
      } = error.response
      errors.forEach(err => {
        let entries = Object.entries(err)
        entries.map(([key] = entry) => {
          return toast.error(`[${key}]: 必須項目です。`)
        })
      })
    }
  }

  const categoryOption =
    categoryList.length > 0 &&
    categoryList?.map(v => ({
      value: v?.id,
      label: v?.name,
    }))

  const categoryValue =
    categoryList.length > 0 &&
    categoryOption.find(val => val.value === field.categoryId)

  const productOption =
    productList.length > 0 &&
    productList?.map(v => ({
      value: v?.id,
      label: v?.productName,
    }))

  const productValue =
    productList.length > 0 &&
    productOption.find(val => val.value === field.productId)

  React.useEffect(() => {
    dispatch(getProductCategoryList())
  }, [dispatch, id])

  React.useEffect(() => {
    if (id) {
      setFormState("edit")
      getSpecificationByIdAPI(id).then(dataById => {
        setField(dataById.data)
      })
    }
  }, [id])

  return (
    <div className="page-content" style={{ height: "575px" }}>
      <Container fluid>
        <Breadcrumb title={"仕様マスター"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={8}>
                <p className="fw-bold">
                  {id ? "仕様マスター詳細" : "新規仕様マスター追加"}
                </p>
              </Col>
              <Col className="d-flex justify-content-end">
                <SButton
                  disabled={isSubmitting}
                  className="button"
                  onClick={onSubmit}
                >
                  {isSubmitting ? "Loading..." : "保存"}
                </SButton>
                <BackButton className="ms-2 button" />
              </Col>
            </Row>
            <Row>
              <Col md={2} className="col-form-label">
                <Label className="form-label">
                  商品カテゴリー<span className="text-danger">*</span>
                </Label>
              </Col>
              <Col md={6}>
                <SelectBox
                  onChange={e => {
                    setField({ ...field, categoryId: e.value })
                    dispatch(getProductList({ categoryId: e.value }))
                  }}
                  options={categoryOption}
                  value={categoryValue}
                  isDisabled={formState === "edit"}
                />
              </Col>
            </Row>
            <Row>
              <Col md={2} className="col-form-label">
                <label className="">商品名</label>
              </Col>
              <Col md={6}>
                <SelectBox
                  onChange={e =>
                    setField({
                      ...field,
                      productId: e.value,
                      productName: e.label,
                    })
                  }
                  options={productOption}
                  value={{ label: field.productName, value: field.productId }}
                  isDisabled={formState === "edit" || field.categoryId === 0}
                />
              </Col>
              <Col md={2} className="col-form-label">
                ※任意できます。
              </Col>
            </Row>
            <Row>
              <Col md={2} className="col-form-label">
                <Label className="form-label">
                  項目<span className="text-danger">*</span>
                </Label>
              </Col>
              <Col md={6} className="">
                <Input
                  name="item"
                  value={field.item}
                  onChange={e => setField({ ...field, item: e.target.value })}
                />
              </Col>
            </Row>
            <Row>
              <Col md={2} className="col-form-label">
                <Label className="form-label">
                  形式<span className="text-danger">*</span>
                </Label>
              </Col>
              <Col md={6}>
                <SelectBox
                  options={formatOption}
                  onChange={e => {
                    if (e.value !== "TEXT") {
                      setField({
                        ...field,
                        format: e.value,
                      })
                    } else {
                      setField({ ...field, format: e.value, labels: [] })
                    }
                  }}
                  isDisabled={formState == "edit"}
                  value={formatOption.find(v => v.value === field.format)}
                />
              </Col>
            </Row>
            {field.format !== "TEXT" ? (
              <>
                <Row>
                  <Col md={2} className="col-form-label">
                    <Label className="form-label">
                      回答<span className="text-danger">*</span>
                    </Label>
                  </Col>
                  <Col md={6}>
                    <SelectBox
                      onChange={e => {
                        let labels = []
                        for (let i = 0; i < e.value; i++) {
                          labels.push({
                            sequence: i + 1,
                            label: "",
                          })
                        }
                        setField({ ...field, labels: labels, answer: e.value })
                      }}
                      value={answerOption.find(v => v.value === field.answer)}
                      options={answerOption}
                      isDisabled={formState === "edit"}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={2}></Col>
                  <Col sm={6}>
                    <Row className="mt-2">
                      {field.labels.map((item, index) => {
                        return (
                          <Col sm={3} key={item.sequence} className="mb-3">
                            <Input
                              value={item.label}
                              onChange={e => {
                                let _temp = [...field.labels]
                                _temp[index].label = e.target.value
                                setField({ ...field, labels: _temp })
                              }}
                              disabled={formState === "edit"}
                              readOnly={formState === "edit"}
                            />
                          </Col>
                        )
                      })}
                    </Row>
                  </Col>
                </Row>
              </>
            ) : (
              ""
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default SpecificationManagement
